<div>

    <div class="fundo-aspectos-servicos">

        <div class="uk-container">
            <div class="uk-container uk-text-center" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                <h1 class="uk-margin-medium-top titile"><b>Uma infraestrutura distribuída e resiliente</b></h1>
                <p style="color: #666; font-size: 1.05rem; max-width: 560px; margin: 10px auto 0;">
                    Tudo o que precisa para crescer online, reunido numa plataforma de alta disponibilidade.
                </p>
            </div>

            <div class="uk-margin-medium-top uk-margin-medium-bottom uk-margin-medium-right uk-margin-medium-left">
                <div class="uk-child-width-1-4@l uk-child-width-1-1@s espaco uk-grid-match uk-grid uk-text-left" uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
                    <div>
                        <div class="uk-card fundo-aspectos uk-border-rounded uk-card-body">
                            <div class="feature-icon-wrapper">
                                <span uk-icon="icon: desktop; ratio: 1.5"></span>
                            </div>
                            <h3 class="uk-card-title"><b>Interface<br>Amigável</b></h3>
                            <p>Gerencie os seus recursos com facilidade utilizando o cPanel. Envie e receba e-mails com
                                facilidade usando o Webmail.</p>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card fundo-aspectos uk-border-rounded uk-card-body">
                            <div class="feature-icon-wrapper">
                                <span uk-icon="icon: lock; ratio: 1.5"></span>
                            </div>
                            <h3 class="uk-card-title"><b>Seguro<br>e Estável</b></h3>
                            <p>A nossa infraestrutura é baseada em Linux, garantindo segurança e estabilidade contínua.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card fundo-aspectos uk-border-rounded uk-card-body">
                            <div class="feature-icon-wrapper">
                                <span uk-icon="icon: cart; ratio: 1.5"></span>
                            </div>
                            <h3 class="uk-card-title"><b>Baixo<br>Custo</b></h3>
                            <p>Só cobramos o que usa e temos planos para todas as demandas. Cresça de acordo com as suas
                                necessidades.</p>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card fundo-aspectos uk-border-rounded uk-card-body">
                            <div class="feature-icon-wrapper">
                                <span uk-icon="icon: bolt; ratio: 1.5"></span>
                            </div>
                            <h3 class="uk-card-title"><b>Baixa<br>Latência</b></h3>
                            <p>Estamos conectados à infraestrutura local e interconectados com as principais redes de
                                conteúdo e trânsito.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

